export type PostpaidDetails = {
	productId: string;
	amount: string;
	isOneOff: string;
};

export type ProductInfo = {
	propertyName: string;
	propertyValue: string;
};

export type BasicPlan = {
	productName: string;
	productId: string;
	productInfo: ProductInfo[];
	postpaidDetails: PostpaidDetails;
	roaming: boolean;
};

export type CommitmentProductBenefit = {
	freeUnitsProductName: string;
};

export type Commitments = {
	productId: string;
	parentPlanProductId: string;
	productBenefits: CommitmentProductBenefit[];
};

export type PlanCommitments = {
	commitmentDuration: string;
	commitments: Commitments[];
};

export type Product = {
	isOneOff: boolean;
	price: string;
	productId: string;
	productName: string;
	requiredTariffPlans: string[];
};

export type TariffPlan = {
	name: string;
	basicPlans: BasicPlan[];
	planCommitments: PlanCommitments[];
};

export type CommercialProduct = {
	productGroup: string;
	productGroupName: string;
	products: Product[];
};

export type TechnicalProduct = {
	productId: string;
	productName: string;
};

export type ProductsDetailsResponse = {
	tariffPlans: TariffPlan[];
	commercialProducts: CommercialProduct[];
	technicalProducts: TechnicalProduct[];
};

export type ProductsDetails = {
	_productDetails: any;
	productDetails: ProductsDetailsResponse;
};

const model: types.models.InputModel = {
	productDetails: ['response.productDetails', []],
};

export default model;
